module.exports = __webpack_public_path__ + "img/index-ico3.c170c849.png";